import Dexie from 'dexie'

// Initialize Dexie database
export const db = new Dexie('short-video')

// Step 1: Version 1 – Original schema
db.version(1).stores({
    likes: 'videoId, domainSource, userId', // old schema with videoId as primary key
})

// Step 1: Remove old table (set to null)
db.version(2)
    .stores({
        likes: null,
    })
    .upgrade(() => {
        console.log('Removed old likes table.')
    })

// Step 2: Create new table with compound index
db.version(3)
    .stores({
        likes: '[videoId+userId+domainSource], videoId, userId, domainSource',
    })
    .upgrade(() => {
        console.log('Created new likes table with compound index.')
    })

// Function to like a video
export const likeVideo = async (videoId, userId) => {
    try {
        const domainSource = window.location.hostname // Get current domain
        await db.likes.put({ videoId, userId, domainSource, liked: true })
        console.log(`Liked video: ${videoId} from ${domainSource} by user ${userId}`)
    } catch (error) {
        console.error('Error liking video:', error)
    }
}

// Function to unlike a video
export const unlikeVideo = async (videoId, userId) => {
    try {
        const domainSource = window.location.hostname
        await db.likes.where({ videoId, userId, domainSource }).delete()
        console.log(`Unliked video: ${videoId}`)
    } catch (error) {
        console.error('Error unliking video:', error)
    }
}

// Function to check if a video is liked
export const isVideoLiked = async (videoId, userId) => {
    try {
        const domainSource = window.location.hostname
        const likedVideo = await db.likes.where({ videoId, userId, domainSource }).first()

        return !!likedVideo // Returns true if found, otherwise false
    } catch (error) {
        console.error('Error checking video like status:', error)
        return false
    }
}

// Function to get all liked videos for a user on the current domain
export const getLikedVideos = async (userId) => {
    try {
        const domainSource = window.location.hostname
        const likedVideos = await db.likes.where({ userId, domainSource }).toArray() // Get all liked videos

        return likedVideos
    } catch (error) {
        console.error('Error fetching liked videos:', error)
        return []
    }
}
